<!-- 临时提示组件[主要用于 基础数据变更的提示操作] -->
<template>
  <div v-if="visible" class="tip">
    <i class="el-icon-warning-outline" style="color:red;font-weight: bold;" />
    <div class="content">{{ $t('Message.AfterTheCorrespondingCacheData') }}</div>
    <el-link type="primary" class="link" @click="showSteps">{{ $t('Message.ViewCacheRefreshMethod') }}</el-link>
    <el-dialog :visible.sync="stepsDialog.show" :title="$t('Message.RefreshCacheMethod')">
      <el-carousel :interval="4000" height="450px" weight>
        <el-carousel-item v-for="item in stepsDialog.stepsImgUrl" :key="item">
          <img :src="item" height="100%" width="100%">
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>
<script>
import refreshCacheStep1 from '@/assets/refresh-cache-step1.png'
import refreshCacheStep2 from '@/assets/refresh-cache-step2.png'

export default {
  name: 'Tip',
  data() {
    return {
      visible: false,
      stepsDialog: {
        show: false,
        stepsImgUrl: [refreshCacheStep1, refreshCacheStep2]
      }

    }
  },
  watch: {
    $route(route) {
      this.toggleVisible()
    }
  },
  created() {
    this.toggleVisible()
  },
  methods: {
    toggleVisible() {
      if (this.$route.path && this.$route.path.startsWith('/Information/')) {
        this.visible = true
      } else {
        this.visible = false
      }
    },
    showSteps() {
      this.stepsDialog.show = true
    }
  }
}
</script>
<style scoped lang="scss">
.tip{
  margin: 5px auto;
  background-color: rgba(255, 165, 0, 0.13);
  padding: 5px 10px;
  height: 35px;
  line-height: 35px;
  display: flex;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  font-size: 13px;
  align-items: center;
  .content{
    color:orange;
    margin-left: 5px;
  }
  .link{
    align-self:center;
    height: 15px;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
}
</style>
